import { Injectable } from "@angular/core";
import { DocumentInterruptSource, Idle } from "@ng-idle/core";

@Injectable({
  providedIn: "root",
})
export class IdleUserService {
  constructor(private idle: Idle) {}

  readonly TIMEOUT = 15 * 60;

  setUserIdle() {
    this.idle.setIdle(this.TIMEOUT);
    this.idle.setTimeout(this.TIMEOUT);
    this.idle.setInterrupts([new DocumentInterruptSource("keydown mousedown mousemove touchstart touchmove scroll")]);
    this.idle.watch();
  }

  idleTimeout() {
    return this.idle.onTimeout;
  }

  idleWatch() {
    this.idle.watch();
  }
}
